import React from 'react';

import Button from 'CommonComponents/Button';

import LinkIcon from 'Assets/icons/link.svg';

/**
 * Milestones exist, but none within the critical path's float of the target survive the filters, or
 * the event has no key milestone to measure against (noTarget).
 */
const RoadmapCriticalEmptyState = ({ noTarget, onResetFilters, onTurnOff }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-px-6 tw-py-16 tw-border tw-border-charcoal-25 tw-rounded-lg">
        <div className="tw-flex tw-items-center tw-justify-center tw-h-14 tw-w-14 tw-rounded-full tw-bg-red-10 tw-mb-4">
            <LinkIcon className="tw-h-6 tw-w-6 tw-text-red" aria-hidden="true" />
        </div>
        <h4 className="tw-text-base tw-font-semibold tw-text-charcoal tw-mb-1">
            {noTarget ? $t('No key milestones to measure against') : $t('No critical milestones in this period')}
        </h4>
        <p className="tw-text-sm tw-text-charcoal-75 tw-max-w-sm tw-mb-4">
            {noTarget
                ? $t('Mark a milestone as a key milestone in the project plan to see its critical path.')
                : $t('Choose another target, widen the Period or filters, or turn off Critical path to see every milestone.')}
        </p>
        <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-2">
            {!noTarget && (
                <Button variant="secondary" small onClick={onResetFilters}>
                    {$t('Reset filters')}
                </Button>
            )}
            <Button variant="secondary" small onClick={onTurnOff}>
                {$t('Turn off critical path')}
            </Button>
        </div>
    </div>
);

export default RoadmapCriticalEmptyState;
